import { ReactElement } from 'react';

// Trial extension offer disabled — replaced by introductory discount at checkout.
// To re-enable, restore the full component from git history (feat: disable trial extension ribbon).
export function TrialExtensionRibbon(): ReactElement | null {
  return null;
}
